import * as React from 'react';
import { useNonNullishContext } from '../../../react/hooks/use-non-nullish-context.js';

/**
 * @deprecated
 */ const LegacyModalDialogContext = /*#__PURE__*/ React.createContext(null);
LegacyModalDialogContext.displayName = 'LegacyModalDialogContext';
/**
 * @deprecated
 */ function useLegacyModalDialogContext() {
    return useNonNullishContext(LegacyModalDialogContext);
}

export { LegacyModalDialogContext, useLegacyModalDialogContext };
